var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "globe") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.617,19.552 C15.666,18.054 16.757,15.851 16.975,13 L19.93,13 C19.547,16.052 17.441,18.57 14.617,19.552 L14.617,19.552 Z M4.069,13 L7.061,13 C7.267,15.862 8.344,18.056 9.407,19.561 C6.57,18.584 4.454,16.061 4.069,13 L4.069,13 Z M9.438,4.429 C8.386,5.927 7.285,8.137 7.065,11 L4.069,11 C4.455,7.928 6.586,5.397 9.438,4.429 L9.438,4.429 Z M9.079,11 C9.385,7.728 11.059,5.45 12.026,4.397 C13.026,5.468 14.674,7.725 14.959,11 L9.079,11 Z M9.08,13 L14.962,13 C14.656,16.277 12.978,18.555 12.012,19.608 C10.965,18.498 9.359,16.272 9.08,13 L9.08,13 Z M19.93,11 L16.978,11 C16.773,8.151 15.708,5.964 14.65,4.461 C17.458,5.451 19.549,7.96 19.93,11 L19.93,11 Z M22,12 C22,6.496 17.529,2.018 12.028,2.002 C12.024,2.002 12.02,2.001 12.015,2.001 C12.011,2.001 12.005,2 12,2 C6.486,2 2,6.487 2,12 C2,17.514 6.486,22 12,22 C12.006,22 12.011,21.999 12.015,21.999 C12.017,21.999 12.018,22 12.02,22 C12.023,22 12.026,21.998 12.028,21.998 C17.529,21.983 22,17.504 22,12 L22,12 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "globe",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\uD83C\\uDFA8-Icon-\\u0421olor",
    fill: "#0D1C2E",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.ae69b7949dbf1fca0fbc6b790458135a.svg";
export { ForwardRef as ReactComponent };